import React, { useState, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import PropTypes from 'prop-types';

const Captcha = ({ onCaptchaChange }) => {
  const [captchaKey, setCaptchaKey] = useState(Date.now());

  const handleCaptcha = (token) => {
    if (token) {
      onCaptchaChange(token);
    } else {
      console.error("Captcha token is null or undefined");
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setCaptchaKey(Date.now());
    }, 60000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      margin: '10px 0',
      transform: 'scale(0.9)',
      transformOrigin: 'center'
    }}>
      <ReCAPTCHA
        key={captchaKey}
        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
        onChange={handleCaptcha}
        data-theme="light"
      />
    </div>
  );
};

// PropTypes validation
Captcha.propTypes = {
  onCaptchaChange: PropTypes.func.isRequired,
};

export default Captcha;